import { PageType } from "@product/scmp-sdk";

export const pathname = "/page";

export const page = {
  route(query: QueryParameters<{ entityId: string }>) {
    return { pathname, query: { ...query, pageType: PageType.Page } };
  },
};
